const testimonials = [
  {
    name: "Jessica H.",
    location: "Sioux Falls, SD",
    stars: 5,
    text: "I had a family emergency abroad and needed my passport renewed within days. Fast Passport Center walked me through everything and had my passport back in 5 days. No Denver trip needed — huge relief from Sioux Falls.",
    date: "March 2025",
  },
  {
    name: "Tom & Sarah K.",
    location: "Brandon, SD",
    stars: 5,
    text: "We were renewing passports for our whole family before an international trip. Our agent caught a mistake on one of our forms before submission. Everything arrived on time. Worth every penny.",
    date: "January 2025",
  },
  {
    name: "Marcus D.",
    location: "Harrisburg, SD",
    stars: 5,
    text: "I always assumed I had to drive to Minneapolis or Denver to get a passport quickly. Fast Passport Center proved me wrong. Got mine in 7 days, delivered straight to my door.",
    date: "April 2025",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Customer Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Sioux Falls Residents Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Trusted by thousands of South Dakota passport applicants. Here&apos;s what Sioux Falls travelers have to say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-center gap-0.5 mb-4">
                {[...Array(t.stars)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-gray-300 text-xs">{t.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-white rounded-lg border border-gray-200 p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#F6C344] text-lg"></i>
              ))}
            </div>
            <div>
              <p className="font-bold text-[#1A365D] text-lg">4.9 out of 5</p>
              <p className="text-gray-400 text-sm">Based on 2,800+ verified reviews</p>
            </div>
          </div>
          <div className="flex items-center gap-6 text-sm text-gray-500">
            <div className="flex items-center gap-1.5">
              <i className="ri-award-line text-[#F6C344]"></i>
              <span>A+ BBB Rating</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-[#F6C344]"></i>
              <span>State Dept. Registered Courier</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}